<button (click)="increase()">Increase</button>
<button [disabled]="disableDecrease$ | async" (click)="decrease()">
  Decrease
</button>
<button [disabled]="disableDecrease$ | async" (click)="clear()">Clear</button>

<div>
  <span
    >Counter is: {{ count$ | async }} <br />
    Update at: {{ updatedAt$ | async | date: "yyyy-MM-dd-hh:mm:ss" }}</span
  >
</div>
